import React from "react"
import Svg, { Path } from "react-native-svg"

const ArrowUp = () => (
  <Svg width={20} height={20} viewBox="0 0 20 20" fill="none">
    <Path fill="#F0830E" d="M13.825 13.084L10 9.272l-3.825 3.812L5 11.911l5-4.994 5 4.994-1.175 1.173Z" />
  </Svg>
)
export default ArrowUp
